module.exports = __webpack_public_path__ + "img/box-03.8e980d6f.jpg";